<template>
   <el-container class="wrapper">
    <el-header><HeaderDom></HeaderDom></el-header>
    <el-container>
      <el-main class="content-box">
          <div class="content">
            <div class="content-y">
              <div class="content-main">
                <router-view></router-view>
              </div>
            </div>
          </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
//引入Header Component
import HeaderDom from '@/views/common/layout/HeadDom'

export default {
  data(){
    return {
      collapse: false
    }
  },
  components: {
    HeaderDom
  },
  computed: { 
    routes() {
      return this.$router.options.routes;
    }
  },
  methods: {
    
  }
};
</script>
<style scoped>
.el-header,
.el-footer {
  /* background-color: #2d1113; */
  background-color:#0f44c1;
  color: #333;
  text-align: center;
  line-height: 50px;
}
.el-main {
  padding: 0;
  font-size: 14px;
}
.content-box {
    position: absolute;
    left: 0px;
    right: 0;
    top: 60px;
    bottom: 0;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #fff; 
    display: flex;
    flex-direction: column;
}
.content {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    overflow-y: hidden;
}
.content-y {
  overflow-y: auto;
}
.content-main {
  margin: 10px 20px 20px 20px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/common/module/Module.vue